import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from '../../models'

import type { State } from './state'

/**
 * Core actions for this feature
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /* eslint-disable sort-keys */
    render: store.actions.request({
      input: store.actions.Data.asIs<models.segment.Request>(),
      output: store.actions.Data.asIs<{
        rendering: ents.core.mosaic.Page.Segment.Rendering
      }>(),
      reducers: {
        request: ({ data: { alias }, state }) => ({
          ...state,
          segmentInfoLookup: {
            ...state.segmentInfoLookup,
            [alias]: {
              isLoading: true,
            },
          },
        }),
        success: ({
          data: {
            request: { alias },
            response: { rendering },
          },
          state,
        }) => ({
          ...state,
          segmentInfoLookup: {
            ...state.segmentInfoLookup,
            [alias]: { isLoading: false, rendering },
          },
        }),
        error: ({
          data: {
            request: { alias },
            error,
          },
          state,
        }) => ({
          ...state,
          segmentInfoLookup: {
            ...state.segmentInfoLookup,
            [alias]: { error, isLoading: false },
          },
        }),
        /* eslint-enable sort-keys */
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
